import { Map }     from 'immutable';
import { Reducer } from '../../Reducer';
import * as TYPES  from './types';

const DEFAULT_STATE = Map({
    loading: false,
});

export default class PageReducer extends Reducer {
    NAME = 'Page';
    alias = {
        [ TYPES.PAGE_LOADING ]: 'onPageLoading',
    };

    /**
     * Show loader when the page/action are _loading
     * @param state
     * @param action
     * @returns {*}
     */
    onPageLoading ( state = DEFAULT_STATE, action ) {
        return state.set('loading', action.payload);
    }

    onDefault ( state = DEFAULT_STATE ) {
        return state;
    }
}
